import { cn } from "../../../lib/cn";

type ProjectsNavProps = {
  activeIndex: number;
  disabled?: boolean;
  total: number;
  onNext: () => void;
  onPrev: () => void;
  onSelect: (index: number) => void;
};

export function ProjectsNav({ activeIndex, disabled = false, onNext, onPrev, onSelect, total }: ProjectsNavProps) {
  return (
    <div className="projects-nav" data-carousel-control="true">
      <div className="projects-nav__buttons">
        <button
          data-carousel-control="true"
          className="projects-nav__button projects-nav__button--prev"
          disabled={disabled}
          onClick={onPrev}
          type="button"
        >
          <span aria-hidden="true">←</span>
          <span className="projects-nav__label">Prev</span>
        </button>
        <div className="projects-nav__dots" aria-label="Project selection">
          {Array.from({ length: total }, (_, index) => (
            <button
              aria-label={`Go to project ${index + 1}`}
              aria-current={activeIndex === index ? "true" : undefined}
              className={cn("projects-nav__dot", activeIndex === index && "projects-nav__dot--active")}
              data-carousel-control="true"
              disabled={disabled}
              key={index}
              onClick={() => onSelect(index)}
              type="button"
            />
          ))}
        </div>
        <button
          data-carousel-control="true"
          className="projects-nav__button projects-nav__button--next"
          disabled={disabled}
          onClick={onNext}
          type="button"
        >
          <span aria-hidden="true">→</span>
          <span className="projects-nav__label">Next</span>
        </button>
      </div>
    </div>
  );
}
